
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { authAPI } from '../api';
import { useTranslation } from '../i18n';
import { toast } from '../components/common/Notifier';

export const ForgotPasswordPage = () => {
  const { t } = useTranslation();
  const [usernameOrEmail, setUsernameOrEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await authAPI.requestPasswordReset(usernameOrEmail);
      setSent(true);
    } catch (error) {
      toast.error(t('error.general'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center py-12 px-4 bg-gradient-to-b from-blue-50 to-white">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-xl p-8 space-y-6">
        <h1 className="text-2xl font-bold text-gray-800 text-center">
          {t('forgot_password.title')}
        </h1>

        {sent ? (
          <div className="text-center space-y-4">
            <p className="text-gray-600">{t('forgot_password.sent_message')}</p>
            <Link to="/login" className="text-blue-600 hover:text-blue-800 text-sm">
              {t('forgot_password.back_to_login')}
            </Link>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700">
                {t('forgot_password.username_or_email')}
              </label>
              <input
                type="text"
                required
                value={usernameOrEmail}
                onChange={(e) => setUsernameOrEmail(e.target.value)}
                className="mt-1 block w-full px-3 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500"
                placeholder={t('forgot_password.placeholder')}
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              className="w-full py-3 px-4 rounded-xl text-white bg-blue-600 hover:bg-blue-700 disabled:opacity-50 transition-all"
            >
              {loading ? t('common.loading') : t('forgot_password.submit_button')}
            </button>

            <div className="text-center">
              <Link to="/login" className="text-sm text-blue-600 hover:text-blue-800">
                {t('forgot_password.back_to_login')}
              </Link>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};